import React from 'react';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle,
} from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';

export default function EditNotesDialog({
  open,
  onOpenChange,
  formData,
  setFormData,
  onSave,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle className="font-heading">Notes techniques du consultant</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 mt-4">
          <div>
            <Label htmlFor="leads_count">Nombre de formulaires reçus ce mois</Label>
            <Input
              id="leads_count"
              type="number"
              value={formData.leads_count}
              onChange={(e) => setFormData({ ...formData, leads_count: parseInt(e.target.value) || 0 })}
              className="mt-1"
              data-testid="notes-leads-count"
            />
          </div>
          <div>
            <Label htmlFor="consultant_notes">Actions techniques réalisées</Label>
            <Textarea
              id="consultant_notes"
              value={formData.consultant_notes}
              onChange={(e) => setFormData({ ...formData, consultant_notes: e.target.value })}
              placeholder="Décrivez les actions SEO réalisées ce mois...&#10;- Optimisation des balises title&#10;- Création de 5 articles de blog&#10;- Correction des erreurs 404"
              className="mt-1"
              rows={8}
              data-testid="notes-consultant-notes"
            />
          </div>
          <div className="flex justify-end gap-3 pt-4">
            <Button variant="outline" onClick={() => onOpenChange(false)}>Annuler</Button>
            <Button className="bg-[#002FA7] hover:bg-[#002277]" onClick={onSave} data-testid="notes-save-btn">
              Enregistrer
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
